import { log as pilog } from "@limitless/common/utils/Logging";
export const shouldBlockAppEntry = (platform, upgradeResource) => {
  const log = pilog.getLogger("UpgradeUtil shouldBlockAppEntry");
  log.debug(`Calculating app entry for ${platform} ${process.env.REACT_APP_VERSION} `, upgradeResource);
  let blockAppEntry = false;
  let osContent = undefined;
  //if we don't know the platform or we don't have any platform resource, don't do anything
  if (!platform || !upgradeResource) {
    return {
      blockAppEntry,
      osContent
    };
  }
  try {
    if (upgradeResource[process.env.REACT_APP_VERSION]) {
      if (upgradeResource[process.env.REACT_APP_VERSION][platform]) {
        osContent = upgradeResource[process.env.REACT_APP_VERSION][platform].content;
        blockAppEntry = true;
      }
    }
  } catch (error) {
    log.error(`Unable to parse content for ${platform}`);
  }
  return {
    blockAppEntry,
    osContent
  };
};